import { gsap } from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

let smoothScroll

let smoothScrollEffects = true
if (window.innerWidth < 1200) smoothScrollEffects = false

let smoothScrollParams = {
  //normalizeScroll: true,
  smooth: 2,   // seconds it takes to "catch up" to native scroll position
  effects: smoothScrollEffects // look for data-speed and data-lag attributes on elements and animate accordingly
}

if (typeof ScrollSmoother === 'function') {

  smoothScroll = ScrollSmoother.create(smoothScrollParams);


  $('.scroll-to-newsletter').on('click', function (e) {
    e.preventDefault()
    smoothScroll.scrollTo('#sign-up-for-news', true)
  })

  // init other functions which need smooth scroll

}

export function smoothScrollPause(){
  smoothScroll.paused(true)
}
export function smoothScrollPlay(){
  smoothScroll.paused(false)
}
export function updateSmoothScroll(){
  ScrollTrigger.refresh()
}
export function smoothScrollKill(){
  smoothScroll.kill()
}
export function smoothScrollCreate(){
  smoothScroll = ScrollSmoother.create(smoothScrollParams);
}
